import { Money } from "types/landlord/reports";

// Give a total object {cents, currency} returns a formatted string
export const formatToCurrency = (
  total: Money | string,
  {
    maximumFractionDigits = 2,
    ceil = false
  }: { maximumFractionDigits?: number; ceil?: boolean } = {}
): string => {
  if (typeof total !== "object") return total;

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency:
      typeof total.currency === "string" && total.currency
        ? total.currency
        : "USD",
    maximumFractionDigits: maximumFractionDigits
  });

  let totalInDollars = total.cents / 100;
  if (ceil) totalInDollars = Math.ceil(totalInDollars);

  return formatter.format(totalInDollars);
};

export const toMoney = (
  value: number | string | null,
  maximumFractionDigits: number = 2
) => {
  if (value === null) return null;
  const USDollar = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits
  });
  return USDollar.format(Number(value));
};
